import React from 'react';
import { motion } from 'framer-motion';
import LazyImage from '../components/common/LazyImage';

const CourseCard = ({ course }) => {
  return (
    <motion.div 
      className="relative bg-gradient-to-br from-white to-gray-50 rounded-lg p-2 h-full overflow-hidden border"
      initial={{ scale: 0.95 }}
      animate={{ scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      {/* Static Background Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(68,68,68,0.02)_25%,rgba(68,68,68,0.02)_50%,transparent_50%,transparent_75%,rgba(68,68,68,0.02)_75%)]
                      bg-[length:20px_20px] opacity-20" />
      
      {/* Main Content Container */}
      <div className="relative h-full">
        {/* Image with Clip Path */}
        <motion.div 
          className="w-full rounded-lg overflow-hidden 
                    clip-path-[polygon(20%_0%,100%_0%,100%_100%,0%_100%)]"
          transition={{ duration: 0.3 }}
        >
          <div>
          <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/20 to-rose-500/20 mix-blend-overlay" />
          
          </div>
          <LazyImage
            src={course.image}
            alt={course.title}
            className="w-full h-52"
          />
        </motion.div>

        {/* Text Content */}
        <div className="z-10 pt-8">
          {/* Decorative Line */}
          <motion.div 
            className="w-12 h-1 bg-gradient-to-r from-indigo-500 to-rose-500 rounded-full mb-6"
            whileHover={{ width: '3rem' }}
            transition={{ duration: 0.3 }}
          />
          
          <p className='text-sm text-red-600 mb-4 bg-red-100 w-fit py-1 px-3 rounded-full'>{course.type}</p>
          <h3 className="text-xl font-semibold text-gray-800 mb-4 leading-tight">
            {course.title}
          </h3>
          
          <p className="text-gray-800 leading-relaxed">
            {course.description}
          </p>
        </div>
      </div>

      {/* Static Corner Decoration */}
      <motion.div 
        className="absolute -right-4 -bottom-4 w-24 h-24 bg-gradient-to-br from-indigo-500/10 to-rose-500/10 rounded-full"
        initial={{ scale: 0.8, opacity: 0.5 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      />
    </motion.div>
  );
};

export default CourseCard;